/* eslint-disable react-hooks/exhaustive-deps */
import Geolocation from "react-geolocation"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { fetchAPI, getAllCityList, getNearestoutlet } from "lib/api"
import Select from "@components/anti/Forms/components/select"
import { Q_NEAREST_CONCESSION, Q_OUTLET_LIST } from "lib/query"
import { convertHtmlToReact, extractMeta } from "src/mixins"
import SectionNotFound from "@components/global/SectionNotFound"

function ProductsServicesConcessionsLocationComp({
  anim,
  isBallroom,
  latitude,
  longitude,
  concessionId,
  concessionTitle,
  getCurrentPosition,
}) {
  const Router = useRouter()
  const { locale } = Router
  const [state, setState] = useState({
    latitude: null,
    cityOptions: [],
    selectCity: null,
    data: [],
    loading: false,
  })
  const setData = (meta) => {
    const data = extractMeta(meta, "google_maps")
    setTimeout(() => {
      setState((prev) => ({ ...prev, data, loading: false }))
    }, 250)
  }
  const getConcessionByLocation = async (request) => {
    const { lng, lat, cityId } = request
    if (!cityId) {
      setState((prev) => ({ ...prev, loading: true }))
      const nearestOutlet = await getNearestoutlet(
        parseFloat(lat),
        parseFloat(lng),
        null,
        null,
        concessionId
      )
      if (nearestOutlet?.length > 0) {
        const cityOptions = nearestOutlet.map((item) => ({
          label: item.name,
          value: item,
        }))
        const data = await fetchAPI(Q_NEAREST_CONCESSION, {
          variables: {
            concession_id: concessionId,
            city_id: cityOptions[0]?.value?.id,
          },
        })
        setState((prev) => ({
          ...prev,
          cityOptions,
          selectCity: cityOptions[0],
        }))
        setData(data?.concessionLocationByNearest?.data[0]?.meta)
      }
    } else {
      setState((prev) => ({ ...prev, loading: true }))
      const data = await fetchAPI(Q_NEAREST_CONCESSION, {
        variables: {
          concession_id: concessionId,
          city_id: cityId,
        },
      })
      setData(data?.concessionLocationByNearest?.data[0]?.meta)
    }
  }
  const getCityList = async () => {
    const variables = { concession_id: concessionId }
    if (!concessionId) delete variables.concession_id
    const cityList = await getAllCityList({ variables })
    if (cityList?.length > 0) {
      const cityOptions = cityList.map((item) => ({
        label: item.name,
        value: item,
      }))
      const jaksel = cityOptions?.find((item) => item?.value?.id === 73)
      getConcessionByLocation({
        cityId: jaksel?.value?.id || cityOptions[0]?.value?.id,
      })
      setState((prev) => ({
        ...prev,
        cityOptions,
        selectCity: jaksel || cityOptions[0],
      }))
    }
  }
  const onSelectCity = (value) => {
    setState((prev) => ({ ...prev, selectCity: value }))
    getConcessionByLocation({ cityId: value.value.id })
  }
  useEffect(() => {
    getCurrentPosition()
  }, [])
  useEffect(() => {
    if (isBallroom) {
      getConcessionByLocation({ cityId: 8 })
    } else if (latitude && longitude) {
      getConcessionByLocation({ lng: longitude, lat: latitude })
    } else {
      getConcessionByLocation({ lng: 106.827153, lat: -6.175392 })
      // getCityList()
    }
  }, [latitude, longitude])
  return (
    <div className="py-main">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-text pr-md-5">
            <h2 className={`title ${anim(1)}`}>
              {isBallroom
                ? translations[`concession_location_ballroom_${locale}`]
                : translations[`concession_location_${locale}`](
                    concessionTitle
                  )}
            </h2>
            {state?.data?.map_link_url ? (
              <Link
                withArrow
                target="_blank"
                href={state?.data?.map_link_url}
                className={`btn-google ${anim(4)}`}
              >
                {translations[`view_google_maps_${locale}`]}
              </Link>
            ) : null}
            {!isBallroom ? (
              <Select
                className="select-city my-3 my-md-0 w-100 pr-md-3"
                options={state.cityOptions}
                value={state.selectCity}
                onChange={(_, val) => {
                  onSelectCity(val)
                }}
                iconLeft
              />
            ) : null}
          </div>
          <div className="col-md-8 col-maps">
            {!state.loading ? (
              state?.data?.embed_url ? (
                <>{convertHtmlToReact(state?.data?.embed_url)}</>
              ) : (
                <SectionNotFound
                  title={translations[`not_found_concession_title_${locale}`](
                    concessionTitle
                  )}
                  text={translations[`not_found_concession_text_${locale}`]}
                />
              )
            ) : (
              <div className="loading-dots-wrapper">
                <h1 className="loading-dots">Loading</h1>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

function ProductsServicesConcessionsLocation({
  slug,
  concessionId,
  concessionTitle,
}) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-concessions-location" ref={trigger}>
      <Geolocation
        render={({
          fetchingPosition,
          error,
          getCurrentPosition,
          position: { coords: { latitude, longitude } = {} } = {},
        }) => (
          <ProductsServicesConcessionsLocationComp
            anim={anim}
            isBallroom={slug === "the-ballroom"}
            error={error}
            latitude={latitude}
            longitude={longitude}
            concessionId={concessionId}
            concessionTitle={concessionTitle}
            fetchingPosition={fetchingPosition}
            getCurrentPosition={getCurrentPosition}
          />
        )}
      />
    </section>
  )
}

export default ProductsServicesConcessionsLocation
